import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './gatingFormActions';

const initialState = {
  isGatingFormVisible: false,
  showImageGatingForm: false,
  imageId: '',
  showStoryGatingForm: false,
  storyId: '',
  showStoryGatingFormPdf: false,
  format:'',
};

export default handleActions({
  [actions.addGatingForm]: (state, action) => u({
    isGatingFormVisible: true,
    showImageGatingForm: action.payload ? action.payload.showImageGatingForm : false,
    imageId: action.payload ? action.payload.imageId : '',
    showStoryGatingForm: action.payload ? action.payload.showStoryGatingForm : false,
    storyId: action.payload ? action.payload.storyId : '',
    showStoryGatingFormPdf: action.payload ? action.payload.showStoryGatingFormPdf : false,
    format: action.payload ? action.payload.format : '',
  }, state),

  [actions.removeGatingForm]: (state, action) => u({
    isGatingFormVisible: false
  }, state),
  }, initialState);



// WEBPACK FOOTER //
// ./src/redux/gatingFormReducer.js